<template>
	<!-- <v-footer class="pa-3"> -->
	<v-footer app dark class="grey darken-4" height="40">
		<!-- <page-footer></page-footer> -->
		<!-- <v-spacer class="hidden-md-and-up"></v-spacer> -->
		<!-- <div class="md-body-1 mx-2 grey--text " > {{copyRight}} {{ new Date().getFullYear() }} &copy;</div> -->
		<!-- <v-spacer></v-spacer> -->
		<!-- <a class="mx-2 grey--text" :href="designerlink" target="_blank">{{designer}}</a> -->
		<a class="mx-2 grey--text" dir="ltr" :href="designerlink" target="_blank">{{ designer }} &copy; {{ copyRight }}
			{{ new Date().getFullYear() }}</a>
		<v-spacer></v-spacer>
		<div class="grey--text" dir="ltr">{{ $store.state.username }}</div>
		<v-spacer></v-spacer>
		<v-row class="grey--text text-xs-center">
			<!-- <v-row class="grey--text text-xs-center"> -->
			<v-btn v-for="item in icons" :key="item.icon" :href="item.link" class="px-3 mx-3 white--text" icon
				target="_blank">
				<v-icon size="24px">{{ item.icon }}</v-icon>
			</v-btn>
		</v-row>
	</v-footer>
</template>

<script>
// import PageFooter from '@/components/PageFooter';
export default {
	rtl: true,
	name: "AppFooter",
	// components: {
	// 	PageFooter
	// },
	data() {
		return {
			// copyRight: '© Raqamsazan',
			copyRight: "Raqamsazan",
			designer: "",
			designerlink: "http://raqamsazan.ir",
			icons: [
				{
					icon: "mdi-instagram",
					link: "http://www.instagram.com/pazarsystem",
				},
				{
					icon: "mdi-facebook",
					link: "http://www.facebook.com/pazarsoftware",
				},
				{
					icon: "mdi-linkedin",
					link: "http://www.linkedin.com/company/2426505",
				},
				{
					icon: "mdi-telegram",
					link: "http://www.telegram.me/pazarsoftware",
				},
			],
		};
	},
};
</script>

<style>
a {
	color: #fff;
	text-decoration: none;
}

a:hover {
	color: #ffee00;
}
</style>
